import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { ReactNode, useState } from 'react';

import { Icon } from '@/components/core/Icon';

import { FilterMenuItem } from './FilterMenuItem';

interface FilterSubmenuProps {
    label: string;
    query: string;
    matchesQuery: boolean;
    children: ReactNode;
    hasMatchingChildren: boolean;
}

export function FilterSubmenu({
    label,
    query,
    matchesQuery,
    children,
    hasMatchingChildren,
}: FilterSubmenuProps) {
    const [open, setOpen] = useState(false);
    const visible = matchesQuery || hasMatchingChildren;
    // Legacy Angular keeps nested options visible while filtering; expand any
    // section that remains after the query so children are not hidden behind a click.
    const expanded = open || Boolean(query);

    if (!visible) {
        return null;
    }

    return (
        <li className="tw-list-none">
            <FilterMenuItem
                preventClose
                isActive={expanded}
                onSelect={() => setOpen((previous) => !previous)}
            >
                <span className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-4">
                    <span>{label}</span>
                    <Icon
                        icon={expanded ? ChevronDownIcon : ChevronRightIcon}
                        size="xs"
                        className="tw-text-t-secondary tw-shrink-0"
                    />
                </span>
            </FilterMenuItem>
            {expanded && <ul className="tw-list-none tw-m-0 tw-p-0">{children}</ul>}
        </li>
    );
}
